import React, { useState } from "react";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة حجم العينة - احسب حجم العينة وهامش الخطأ بدقة";
const DESCRIPTION =
  "احسب حجم العينة المثالي لدراستك أو مسحك بدقة من المجتمع المستهدف باستخدام حاسبة حجم العينة المتقدمة. أدخل بيانات مثل حجم المجتمع، مستوى الثقة المطلوب، وهامش الخطأ المسموح به للحصول على نتائج موثوقة. هذه الأداة أساسية للباحثين، والمحللين الإحصائيين، وخبراء المسوح لضمان دقة النتائج العلمية.";
const KEYWORDS =
  "حجم العينة، حاسبة حجم العينة، حجم المجتمع، حساب حجم العينة، مستوى الثقة، هامش الخطأ، باحثون، إحصاء، دقة النتائج، تحليل البيانات، بحث علمي، حساب حجم العينة من المجتمع.";
const OG_URL = "https://do-calculate.com/calculator/ar/sample-size-calculator";
const SampleSizeCalculator = () => {
  const [confidenceLevel, setConfidenceLevel] = useState(95);
  const [marginOfError, setMarginOfError] = useState(5);
  const [populationProportion, setPopulationProportion] = useState(50);
  const [populationSize, setPopulationSize] = useState("");
  const [sampleSize, setSampleSize] = useState(null);
  const [error, setError] = useState("");
  const [marginSampleSize, setMarginSampleSize] = useState(100);
  const [marginPopulationProportion, setMarginPopulationProportion] =
    useState(60);
  const [calculatedMarginOfError, setCalculatedMarginOfError] = useState(null);
  const handleCalculateSampleSize = () => {
    try {
      if (
        isNaN(confidenceLevel) ||
        isNaN(marginOfError) ||
        isNaN(populationProportion) ||
        (populationSize && isNaN(populationSize))
      ) {
        throw new Error("Please enter valid numbers.");
      }
      const zValues = {
        90: 1.645,
        95: 1.96,
        99: 2.576,
      };
      const z = zValues[confidenceLevel];
      if (!z) throw new Error("Unsupported confidence level");
      const e = marginOfError / 100;
      const p = populationProportion / 100;
      const q = 1 - p;
      const sampleSizeWithoutPopulation = (z * z * p * q) / (e * e);
      let finalSampleSize = sampleSizeWithoutPopulation;
      if (populationSize) {
        const N = parseInt(populationSize, 10);
        finalSampleSize =
          (N * sampleSizeWithoutPopulation) /
          (N + sampleSizeWithoutPopulation - 1);
      }
      setSampleSize(Math.ceil(finalSampleSize));
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };
  const handleCalculateMarginOfError = () => {
    try {
      if (
        isNaN(confidenceLevel) ||
        isNaN(marginSampleSize) ||
        isNaN(marginPopulationProportion)
      ) {
        throw new Error("Please enter valid numbers.");
      }
      const zValues = {
        90: 1.645,
        95: 1.96,
        99: 2.576,
      };
      const z = zValues[confidenceLevel];
      if (!z) throw new Error("Unsupported confidence level");
      const p = marginPopulationProportion / 100;
      const q = 1 - p;
      const n = marginSampleSize;
      const marginOfError = z * Math.sqrt((p * q) / n);
      setCalculatedMarginOfError((marginOfError * 100).toFixed(2));
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>حاسبة حجم العينة</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  هذه الحاسبة المتقدمة تمكّنك من تحديد حجم العينة المثالي
                  لدراستك أو استبيانك بدقة عالية. من خلال إدخال معلومات مثل حجم
                  المجتمع المستهدف، مستوى الثقة المطلوب، وهامش الخطأ المقبول،
                  تستطيع الحاسبة تقديم النتيجة المثلى التي تضمن لك دقة النتائج
                  وتحليل موثوق. تُعتبر هذه الأداة ضرورية للباحثين والمحترفين في
                  مجال الإحصاء، حيث تساعدهم في تصميم دراسات واستبيانات فعّالة مع
                  مراعاة العوامل المؤثرة مثل هامش الخطأ. بفضل هذه الحاسبة، يمكنك
                  تحقيق توازن مثالي بين الدقة وتكلفة جمع البيانات، مما يعزز من
                  جودة أبحاثك وموثوقية النتائج المستخلصة.
                </p>
              </div>
            </div>
                <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>حاسبة حجم العينة</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">مستوى الثقة:</label>
                      </b>
                      <select
                        value={confidenceLevel}
                        onChange={(e) =>
                          setConfidenceLevel(parseInt(e.target.value, 10))
                        }
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value={90}>90%</option>
                        <option value={95}>95%</option>
                        <option value={99}>99%</option>
                      </select>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">هامش الخطأ:</label>
                      </b>
                      <input
                        type="number"
                        placeholder="مثال: 5"
                        value={marginOfError}
                        onChange={(e) => setMarginOfError(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          نسبة مجتمع الدراسة:
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="مثال: 50"
                        value={populationProportion}
                        onChange={(e) =>
                          setPopulationProportion(e.target.value)
                        }
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          حجم مجتمع الدراسة:
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="اتركه فارغاً إذا كان غير محدود"
                        value={populationSize}
                        onChange={(e) => setPopulationSize(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculateSampleSize}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  <div>
                    { error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      sampleSize !== null && (
                        <div className="p-3 mb-2 bg-success text-white">
                          <p className="text-white">
                            حجم العينة المطلوب: {sampleSize}
                          </p>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>حاسبة هامش الخطأ</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">مستوى الثقة:</label>
                      </b>
                      <select
                        value={confidenceLevel}
                        onChange={(e) =>
                          setConfidenceLevel(parseInt(e.target.value, 10))
                        }
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value={90}>90%</option>
                        <option value={95}>95%</option>
                        <option value={99}>99%</option>
                      </select>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">حجم العينة:</label>
                      </b>
                      <input
                        type="number"
                        placeholder="مثال: 100"
                        value={marginSampleSize}
                        onChange={(e) => setMarginSampleSize(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          نسبة مجتمع الدراسة:
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="مثال: 60"
                        value={marginPopulationProportion}
                        onChange={(e) =>
                          setMarginPopulationProportion(e.target.value)
                        }
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculateMarginOfError}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  <div>
                    { error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      calculatedMarginOfError !== null && (
                        <div className="p-3 mb-2 bg-success text-white">
                          <p className="text-white">
                            هامش الخطأ: {calculatedMarginOfError}%
                          </p>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>ما هو حجم العينة؟</h3>
            </div>
            <div className="info-section-body">
              <p>
                حجم العينة هو العدد الأدنى من العينات الذي يجب جمعه لضمان أن
                النتائج المستخلصة تكون ممثلة بشكل دقيق للمجتمع المستهدف. على
                سبيل المثال، إذا كنت تقوم بدراسة لمعرفة معدل استهلاك القهوة في
                مدينة تضم 10,000 شخص، فإن حجم العينة الذي تختاره يجب أن يكون
                كبيرًا بما يكفي ليعكس سلوكيات جميع السكان، ولكن دون الحاجة لمسح
                الجميع.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>ما هو هامش الخطأ؟</h3>
            </div>
            <div className="info-section-body">
              <p>
                هامش الخطأ يمثل مدى التفاوت المتوقع بين نتائج العينة ونتائج
                المجتمع ككل. على سبيل المثال، إذا كانت نتائج الاستطلاع تشير إلى
                أن 60% من الأشخاص يفضلون القهوة بنسبة هامش خطأ ±3%، فإن النسبة
                الحقيقية في المجتمع قد تتراوح بين 57% و63%. كلما قل هامش الخطأ،
                زادت دقة النتائج، ولكن يتطلب ذلك عينة أكبر.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>ما هو مستوى الثقة؟</h3>
            </div>
            <div className="info-section-body">
              <p>
                مستوى الثقة هو النسبة المئوية التي تعكس مدى تأكدنا من أن النتائج
                المستخلصة من العينة تعكس الحقيقة في المجتمع بأكمله. على سبيل
                المثال، إذا كان مستوى الثقة 95%، فهذا يعني أنه إذا قمنا بإجراء
                الدراسة 100 مرة، فستكون النتائج صحيحة في 95 مرة منها. مستوى
                الثقة الأكثر شيوعاً هو 95%، ولكن بعض الدراسات قد تتطلب مستوى ثقة
                أعلى مثل 99%، وهو ما يستلزم زيادة في حجم العينة.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                كيف يؤثر حجم المجتمع على حجم العينة؟
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                حجم المجتمع يؤثر بشكل مباشر على حجم العينة المطلوبة. على سبيل
                المثال، إذا كنت تدرس عادات القراءة في قرية صغيرة تضم 200 شخص،
                فإنك قد تحتاج إلى عينة أكبر كنسبة مئوية من المجتمع لضمان دقة
                النتائج مقارنة بدراسة مشابهة في مدينة كبيرة. ولكن إذا كان
                المجتمع المستهدف كبيراً جداً، مثل مليون شخص، فإن زيادة حجم
                العينة قد لا يؤدي إلى تحسن ملحوظ في دقة النتائج، حيث يبدأ
                التأثير النسبي لحجم العينة في التناقص.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SampleSizeCalculator;
